import apiService from "./api.service";

class ProfilePictureService {
    async getUserProfilePicture(id: number) {
        return await apiService.makeApiCall<string>(`/api/users/${id}/profilePicture`, 'get');
    }
}

export default new ProfilePictureService();